import React from "react";

const Dashboard = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: "translateX(-10px)" }} // Adjust the value as needed
    >
      <g filter="url(#filter0_d_561_11195)">
        <rect
          x="21.1787"
          y="11.75"
          width="7.07143"
          height="4.5"
          rx="1.25"
          stroke="#6B7280"
          strokeWidth="1.5"
        />
        <rect
          x="11.75"
          y="23.75"
          width="7.07143"
          height="4.5"
          rx="1.25"
          stroke="#6B7280"
          strokeWidth="1.5"
        />
        <rect
          x="11.75"
          y="11.75"
          width="7.07143"
          height="9.64286"
          rx="1.25"
          stroke="#6B7280"
          strokeWidth="1.5"
        />
        <rect
          x="21.1787"
          y="18.6074"
          width="7.07143"
          height="9.64286"
          rx="1.25"
          stroke="#6B7280"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_561_11195"
          x="-8"
          y="-4"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2" dy="2" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_561_11195"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_561_11195"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Dashboard;
